import { useQuery } from '@tanstack/react-query'
import { attendanceApi } from '@/api/attendance'

export interface UseTodayAttendanceOptions {
  enabled?: boolean
}

export function useTodayAttendance(options: UseTodayAttendanceOptions = {}) {
  const { enabled = true } = options
  return useQuery({
    queryKey: ['learner', 'attendance', 'today'],
    queryFn: async () => {
      const res = await attendanceApi.getToday()
      return res.data.data
    },
    enabled,
  })
}
